module.exports = __webpack_public_path__ + "static/media/featured_img.d17b3b6f.png";